import { cloneDeep } from 'lodash';
import request from 'superagent';
import { setFeedback, delayedClearFeedback, clearFeedback } from './feedback';
import { setCustomer } from './customer';
const SET_CREDIT_ACCEPT_STATE_PENDING = 'SET_CREDIT_ACCEPT_STATE_PENDING';
const CLEAR_CREDIT_ACCEPT_STATE = 'CLEAR_CREDIT_ACCEPT_STATE';
const SET_CREDIT_ACCEPT_STATE_ERROR = 'SET_CREDIT_ACCEPT_STATE_ERROR';

const initialState = null;

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_CREDIT_ACCEPT_STATE_PENDING:
			return 'pending';
		case SET_CREDIT_ACCEPT_STATE_ERROR:
			return 'error';
		case CLEAR_CREDIT_ACCEPT_STATE:
			return null;
		default:
			return state;
	}
}

export function setCreditAcceptStatePending(){
  return { type: SET_CREDIT_ACCEPT_STATE_PENDING }
}

export function setCreditAcceptStateError(){
  return { type: SET_CREDIT_ACCEPT_STATE_ERROR }
}

export function clearCreditAcceptState(){
  return { type: CLEAR_CREDIT_ACCEPT_STATE }
}

export function creditActionAccept() {
  return (dispatch, getState)  => {
    if(getState().creditAcceptState !== "pending"){
      dispatch( setCreditAcceptStatePending() );
      request
        .put('/svc/customer/cycle/accept/' )
        .set('Accept', 'application/json')
        .end((err, res) => {

          if (err || res.statusCode !== 200 ){
            return dispatch([
              setCreditAcceptStateError(),
              setFeedback('Could not accept credits. Please check your payment methods in the account page.'),
              delayedClearFeedback()
            ]);
          }
          setCreditPurchaseGA(res, getState().store );

          return dispatch([
            setCustomer(res.body),
            clearCreditAcceptState(),
            setFeedback('Thank you for your purchase of two member credits. Happy reading!'),
            delayedClearFeedback()
          ]);
        });
    }
  }
}

function setCreditPurchaseGA(res, store ) {
  let credit_order = res.body.credit_history[0];
  window.dataLayer.push({
      'ecommerce': {
          'purchase': {
              'actionField': {
                  'id': "credit-" + store.tla.toUpperCase() + credit_order.id.toString(),
                  'revenue': credit_order.price.toString(),
                  'tax': credit_order.tax.toString(),
                  'shipping': '0',
                  'coupon': ''
              },
              'products': [
                {
                  'name' : 'Neglite Credit',
                  'quantity': '2',
                  'price': store.one_credit.toString()
                }
              ]
          }
      }
  });
}

export function creditActionDecline() {
  return dispatch => {
    request
      .put('/svc/customer/cycle/decline')
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err || res.statusCode !== 200 ){
          return dispatch([
            setFeedback('Could not decline credits. Please try again.'),
            delayedClearFeedback()
          ]);
        }
        return dispatch([
          setCustomer(res.body),
          setFeedback('You have skipped this month\'s credits. '),
          delayedClearFeedback()
        ]);
      });
  }
}


// WEBPACK FOOTER //
// ./src/modules/credit_accept_state.js